
















import { Component, Prop } from "vue-property-decorator";
import Vue from "vue";
import { Base, SurveyModel, Cover, CoverCell } from "survey-core";
import { BaseVue } from "../../base";

export * from "./header-cell.vue";
export * from "./header-mobile.vue";

@Component
export class HeaderViewModel extends BaseVue {
  @Prop() model: Cover;
  @Prop() survey: SurveyModel;
  constructor(props: any) {
    super(props);
  }
  getModel(): Cover {
    this.model.survey = this.survey;
    return this.model;
  }
}

Vue.component("sv-header", HeaderViewModel);
export default HeaderViewModel;
